import { handleBlobResponse } from "../../custom/helpers/HandleResponse";
import http from "../core/http";
const group = 'faultLogs';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getMonthListRequest =  async (data) => {
    return await http.post(`${group}/getMonthList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getGuestDataListRequest =  async (data) => {
    return await http.post(`${group}/getGuest`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const findDataRequest =  async (data) => {
    return await http.post(`${group}/find`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const assignDataRequest =  async (data) => {
    return await http.post(`${group}/assign`, data).then(res => res.data).catch(http.defaultCatch);
}

export const completeDataRequest =  async (data) => {
    return await http.post(`${group}/complete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getCategoryListRequest =  async (data) => {
	return await http.post(`${group}/getCategoryList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getSubCategoriesRequest =  async (data) => {
	return await http.post(`${group}/getSubCategories`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getGroupListRequest =  async (data) => {
	return await http.post(`${group}/getGroupList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const syncRequest =  async (data) => {
	return await http.post(`${group}/sync`, data).then(res => res.data).catch(http.defaultCatch);
}



export const exportFaultLogs = async (data) => {
    const response = await http({url: `${group}/export`, method: "POST", data: data, responseType: "blob"}).then(res => res.data).catch(http.defaultCatch);
    handleBlobResponse(response, (data?.DownloadName || 'FaultLogsReport.xlsx'));
}